<script lang="ts">
  import { page } from '$app/stores';
  import SidebarToggle from '$components/SidebarToggle.svelte';
  import { selectedRace } from '$lib/stores';
  import { isRaceClosed, raceStatusBadgeClass } from '$utils/race';
  import { currentTime, formatTime } from '$utils/time';
  import RaceAlertsDropdown from './RaceAlertsDropdown.svelte';
  import RacePagination from './RacePagination.svelte';

  $: ({ race, streamed } = $page.data);

  $: displayRace = $selectedRace ?? $race;

  // check if the race is today
  $: isToday = () => {
    if (!race || !$race?.startTime) return false;
    if (!$race.startTime) return false;
    const today = new Date();
    return (
      $race.startTime.getDate() === today.getDate() &&
      $race.startTime.getMonth() === today.getMonth() &&
      $race.startTime.getFullYear() === today.getFullYear()
    );
  };
</script>

<div
  class="sticky top-0 z-30 flex flex-row border-b border-gray-300 bg-white px-2 py-2 md:flex md:items-center md:justify-between"
>
  <SidebarToggle />
  <RaceAlertsDropdown />
  <div class="ml-2 flex flex-grow flex-col">
    {#if displayRace && $race}
      <div class="flex flex-row place-items-center">
        <span
          class="mr-1 h-4 w-4 rounded-full shadow-sm {raceStatusBadgeClass(
            displayRace,
            true
          )}"
        />
        <h1
          class="text-m font-extrabold leading-6 text-gray-900 md:truncate lg:text-lg"
        >
          {displayRace.meeting?.track} R{displayRace.number}
        </h1>
      </div>
      <div class="flex flex-row">
        {#if isRaceClosed(displayRace)}
          <span class="text-xs font-semibold text-gray-800 lg:text-sm">
            Jumped at {displayRace.actualStartTime
              ? formatTime(displayRace.actualStartTime)
              : formatTime(displayRace.startTime)}
            {#if !isToday()}
              <!-- Show date in format Saturday 19 Oct -->
              {'-'}
              {displayRace.startTime?.toLocaleDateString('en-GB', {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              })}
            {/if}
          </span>
        {:else}
          <span class="text-xs font-semibold text-gray-800 lg:text-sm">
            Jumps at {formatTime(displayRace.startTime)}
            {#if !isToday()}
              <!-- Show date in format Saturday 19 Oct -->
              {'-'}
              {displayRace.startTime?.toLocaleDateString('en-GB', {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              })}
            {/if}
          </span>
        {/if}
      </div>
    {/if}
  </div>
  <RacePagination />
</div>
